import { useCallback, useSyncExternalStore } from 'react';

/**
 * Whether a media query currently matches, kept live as the viewport changes.
 *
 * @param query a CSS media query such as `(min-width: 1280px)`
 * @returns true while the query matches
 */
export function useMediaQuery(query: string): boolean {
  const subscribe = useCallback(
    (notify: () => void) => {
      const media = globalThis.matchMedia(query);
      media.addEventListener('change', notify);
      return () => {
        media.removeEventListener('change', notify);
      };
    },
    [query],
  );
  return useSyncExternalStore(
    subscribe,
    () => globalThis.matchMedia(query).matches,
    () => false,
  );
}
